import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'

class AdminFunctionService {
  static resource = API_RESOURCE.ADMIN_FUNCTIONS

  static signProposal = async (data) => {
    const response = await axios.put(`${this.resource}/signCommercialProposal`, data, {
      responseType: 'blob',
    })
    return response.data
  }

  static generateCostSheetPdf = async (data) => {
    const response = await axios.put(`${this.resource}/generateCostSheetPdf`, data, {
      responseType: 'blob',
    })
    return response.data
  }

  static signCostSheet = async (data) => {
    const response = await axios.put(`${this.resource}/signCostSheet`, data, {
      responseType: 'blob',
    })
    return response.data
  }
  static batchSendQuotationCompletedEmail = async (data) => {
    const response = await axios.put(`${this.resource}/batchSendQuotationCompletedEmail`, data)
    return response.data
  }
}

export default AdminFunctionService
